import * as React from 'react';

// Easter egg: true from 4pm Friday (user's local time) until midnight.
const FRIDAY = 5; // Date#getDay(): 0 = Sunday
const START_HOUR = 16;
const CHECK_INTERVAL_MS = 60_000; // re-check each minute so it flips live at 4pm / midnight

export const isFridayAfternoon = (now: Date = new Date()) =>
  now.getDay() === FRIDAY && now.getHours() >= START_HOUR;

export const useIsFridayAfternoon = () => {
  const [isFriday, setIsFriday] = React.useState(() => isFridayAfternoon());

  React.useEffect(() => {
    const timer = window.setInterval(() => setIsFriday(isFridayAfternoon()), CHECK_INTERVAL_MS);
    return () => window.clearInterval(timer);
  }, []);

  return isFriday;
};
